import {Component, Injector} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {ContactViewModel} from "@app/presentation/pages/contact/contact.view-model";
import {PopupDispatcher} from "@app/presentation/components/errors/popup.dispatcher";
import {PopupMessage, PopupMessageType} from "@app/presentation/components/errors/popup.message";
import {User} from "@app/core/user/domain/entities/user";
import {TranslateService} from "@ngx-translate/core";
import {ExitService} from "@app/presentation/services/exit.service";
import {AccountViewModel} from "@app/presentation/pages/account/account.view-model";
import {DeliveryPoint} from "@app/core/delivery-point/application/dtos/delivery-point";
import {Contact} from "@app/core/contact/domain/contact";
import {RecaptchaAction, RecaptchaService} from "@app/presentation/services/recaptcha/recaptcha.service";
import {firstValueFrom, Observable} from "rxjs";
import {SelectorFieldOption} from "@app/presentation/components/selector-field/selector-field-option";
import {phoneValidator} from "@app/presentation/form-validators/phone-validator";
import {map} from "rxjs/operators";


@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})

export class ContactComponent {

  contactForm = new FormGroup({
    phonePrefix: new FormControl("", Validators.required),
    phone: new FormControl( "", [Validators.required, phoneValidator()]),
    message: new FormControl("", Validators.required),
  });

  isContactLoading$ = this.viewModel.isContactLoading$;
  private deliveryPoint: DeliveryPoint | null | undefined;

  phonePrefixesOptions$: Observable<SelectorFieldOption[]> = this.viewModel.phonePrefixesOptions$.pipe(
      map(options => {
        return options.map(option => ({
          storedValue: option.value,
          shownValue: option.label
        }))
      })
  );

  constructor(
      private accountViewModel: AccountViewModel,
      private viewModel:ContactViewModel,
      private popupDispatcher: PopupDispatcher,
      private translate: TranslateService,
      private injector: Injector,
      private recaptchaService: RecaptchaService,
  ) {
    viewModel.messageSendObservable.subscribe({next: succeed =>this.messageSendWithSucceed()})
    viewModel.userObservable.subscribe({next: user => this.loadFormValues(user)})
    this.popupDispatcher.setNotifier(viewModel.notifier)
    viewModel.getUser()
    this.accountViewModel.getCurrentDeliveryPoint()
        .subscribe({
          next: deliveryPoint => {
              this.deliveryPoint = deliveryPoint
            }
        })
  }

  async onSubmit(): Promise<void> {
    if (this.contactForm.valid) {
      const recaptchaToken = await firstValueFrom(this.recaptchaService.getToken(RecaptchaAction.CONTACT))
      const values = this.contactForm.value;
      const contact: Contact = {
        phonePrefix: values.phonePrefix!,
        phone: values.phone!,
        message: values.message!,
        recaptchaToken: recaptchaToken
      }
        this.viewModel.contact(contact)
    }
  }

  private loadFormValues(user:User) {
    this.contactForm.setValue({
      phonePrefix: "",
      phone: user.telephone ?? "",
      message: "",
    })
  }

  private messageSendWithSucceed() {
    this.contactForm.reset()
    this.popupDispatcher.showMessage(new PopupMessage(this.translate.instant('send_successfully'), PopupMessageType.SnackBar))
    ExitService.exit(this.injector)
  }
}

